import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginationInput } from '@/models/app';

export const fetchScheduledRideHistories = async ({ id, pagination }: { id: number; pagination?: PaginationInput }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      id,
      pagination,
    },
    query: graphql(`
      query ScheduledRideHistories($id: Float!, $pagination: PaginationInputType) {
        scheduledRideHistories(id: $id, pagination: $pagination) {
          count
          rows {
            id
            action
            reason
            data
            createdAt
          }
        }
      }
    `),
  });

  return response.data.scheduledRideHistories;
};
